import classNames from 'classnames';
import React, {useEffect, useMemo, useRef} from 'react';
import InputLabel from '../InputLabel';
import './styles.css';
import TextInput from '../TextInput';

const Radio = ({
  name,
  options,
  checked,
  onChange,
  label,
  help,
  required,
  showHelpTooltip,
  showCustom = false,
  multiple = false,
  customRadioValue,
  customPlaceholder,
  customName,
  customOnChange,
  customValue,
  customRequired = false,
  checkedBold = false,
  errors,
}) => {
  const hiddenRef = useRef(null);

  const isCustomChecked = useMemo(() => {
    if (Array.isArray(customRadioValue)) {
      return showCustom && customRadioValue.some((value) => checked === value);
    } else {
      if (multiple) {
        return showCustom && checked.indexOf(customRadioValue) !== -1;
      } else {
        return showCustom && checked === customRadioValue;
      }
    }
  }, [showCustom, checked, customRadioValue, multiple]);

  useEffect(() => {
    if (multiple && required) {
      if (checked.length === 0) {
        hiddenRef.current.setCustomValidity('Please select at least one option');
      } else {
        hiddenRef.current.setCustomValidity('');
      }
    }
  }, [multiple, required, checked]);

  return (
    <div className={classNames('input-radio', {
      'input-radio--checkbox': multiple,
      'checked--bold': checkedBold,
    })}>
      <InputLabel label={label} help={help} className={'input-radio__list'} errors={errors?.[name]} showHelpTooltip={showHelpTooltip}>
        {multiple && required && (
          <input
            ref={hiddenRef}
            type={'text'}
            className={'input-radio__hidden'}
            required={true}
            value={checked.join(',')}
            tabIndex={-1}
            onFocus={(e) => {
              e.target.blur();
            }}
            onChange={() => {
              // do nothing
            }}
          />
        )}
        {options.map((option, index) => {
          let withCustom = showCustom && option.value === customRadioValue;
          const isChecked = multiple ? checked.includes(option.value) : checked === option.value;

          if (Array.isArray(customRadioValue)) {
            withCustom = showCustom && customRadioValue.includes(option.value);
          }

          return (
            <label key={index} className={'input-radio__item'}>
              <input
                required={required && !multiple}
                className={'input-radio__input'}
                type={multiple ? 'checkbox' : 'radio'}
                name={name}
                value={option.value}
                checked={isChecked}
                onChange={onChange}
              />
              <span className={'input-radio__label'}>
              <div className={'input-radio__label-inner'}>
                <span className={classNames('input-radio__title', {
                  'input-radio__title--bold': option.bold,
                })}>
                  {option.label}
                  {!!option.help && (
                    <span className={'input-radio__help'}>
                      {option.help}
                    </span>
                  )}
                </span>
                {isCustomChecked && withCustom && isChecked && (
                  <TextInput
                    name={customName}
                    error={errors?.[customName]}
                    className={'input-radio__custom'}
                    type={'text'}
                    placeholder={customPlaceholder}
                    value={customValue}
                    onChange={customOnChange}
                    required={customRequired}
                  />
                )}
              </div>
            </span>
            </label>
          )
        })}
      </InputLabel>
    </div>
  );
};

export default Radio;
